// Libs
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

// Components
import { BlogCard } from "../../components/BlogCard/BlogCard";
import { LoadingFallback } from "../../components/LoadingFallback/LoadingFallback";
import { View } from "../../containers/view/View";
import { Blog } from "../../models/Blog";

import api from "../../api";

import styles from "./ProjectsPage.module.scss";
import { previewImage } from "../../constants";

export const ProjectsPage: React.FunctionComponent = () => {
  const [posts, setPosts] = useState<Blog[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const response = await api.blogs.fetchBlogs("11");
      const data = await response.json();
      if (response.status === 200) {
        setPosts(data);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  return (
    <View
      title="Projekti"
      description="U ovoj rubrici pronađite informacije o implementiranim projektima, realizovanim poslovnim savjetovanjima, organizovanim sajmovima zapošljavanja, održanim treninzima i obukama.
    "
    >
      <Helmet>
        <title>Projekti | Agencija Spektar</title>
        <meta name="description" content="Agencija Spektar" />
        <meta property="og:title" content="Projekti | Agencija Spektar" />
        <meta property="og:image" content={previewImage} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Agencija Spektar" />
      </Helmet>

      <View.Content style={{ marginBottom: "15vh" }}>
        <div className={styles.cards}>
          {loading && <LoadingFallback />}
          {!loading && posts.length === 0 ? (
            <p className={styles.text}>Nisu pronađeni projekti.</p>
          ) : (
            posts.map((e) => {
              return <BlogCard blog={e} key={e.id} />;
            })
          )}
        </div>
      </View.Content>
    </View>
  );
};
